import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getAuth, applyActionCode } from "firebase/auth";
import { motion } from "framer-motion";

export const Verify = () => {
  const [searchParams] = useSearchParams();
  const [finalMessage, setFinalMessage] = useState(null);
  const [finalStatus, setFinalStatus] = useState(null);
  const navigate = useNavigate();
  const auth = getAuth();
  const isFinal = useRef(false);

  useEffect(() => {
    const oobCode = searchParams.get("oobCode");
    if (!oobCode) {
      if (!isFinal.current) {
        isFinal.current = true;
        setFinalMessage("Verification code not found.");
        setFinalStatus("error");
      }
      return;
    }

    const verifyEmail = async () => {
      try {
        await applyActionCode(auth, oobCode);
        await auth.currentUser?.reload();
        if (auth.currentUser && auth.currentUser.emailVerified) {
          if (!isFinal.current) {
            isFinal.current = true;
            setFinalMessage("Email successfully verified!");
            setFinalStatus("success");
            setTimeout(() => navigate("/Login"), 3000);
          }
        } else {
          if (!isFinal.current) {
            isFinal.current = true;
            setFinalMessage("Verification failed, please try again.");
            setFinalStatus("error");
          }
        }
      } catch (error) {
        await auth.currentUser?.reload();
        if (auth.currentUser && auth.currentUser.emailVerified) {
          if (!isFinal.current) {
            isFinal.current = true;
            setFinalMessage("Verification code invalid or already used.");
            setFinalStatus("error");
          }
        } else {
          if (!isFinal.current) {
            isFinal.current = true;
            setFinalMessage("Verification code invalid or already used.");
            setFinalStatus("error");
          }
        }
      }
    };

    verifyEmail();
  }, [searchParams, auth, navigate]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);


  return (
    <section
      id="verify"
      className="w-full min-h-screen flex justify-center items-center relative bg-cover bg-center"
      style={{
        backgroundImage: "url('/bg/bghero5.jpg')",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="absolute inset-0 bg-cyan-900 bg-opacity-40 backdrop-blur-sm"></div>

      <div className="relative z-0 flex flex-col items-center text-white w-full px-4 md:px-8">
        <motion.div
          className="w-full sm:w-96 bg-white bg-opacity-40 p-6 rounded-xl shadow-lg backdrop-blur-md"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <p className="text-2xl font-semibold mb-4 text-center">Email Verification</p>
          {finalMessage && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className={`mt-4 p-4 rounded-xl text-center ${finalStatus === "success" ? "bg-lime-600 text-white" : "bg-rose-600 text-white"
                }`}
            >
              <p>{finalMessage}</p>
              {finalStatus === "success" && (
                <p className="text-sm">
                  Please Login again using your email and password!
                </p>
              )}
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

